module.exports = __webpack_public_path__ + "img/logo-jp.df5b83ee.png";